<template>
  <div class="mod-home">
     <el-card class="box-card">
  <el-table :data="tableData" border :span-method="objectSpanMethod" :row-style="selectedstyle"  height="400" @cell-click="handle">
    <el-table-column prop="bumen" label="施工单位" width="160"  fixed></el-table-column>
    <el-table-column prop="name" label="项目名称"   fixed min-width='200px'> </el-table-column>
    <el-table-column label="合同金额（元）" width="120">
          <template slot-scope="scope">
               {{interval.interval(scope.row.amount1)}}
             </template>
    </el-table-column>
    <el-table-column label="实用金额（元）" width="120">
       <template slot-scope="scope">
               {{interval.interval(scope.row.amount2)}}
             </template>
    </el-table-column>
    <el-table-column label="实用方量（m³）" width="130">
      <template slot-scope="scope">
               {{interval.interval(scope.row.amount3)}}
             </template>
      </el-table-column>
    <el-table-column prop="amount4" label="应收款比例" width="100"> </el-table-column>
    <el-table-column label="进度应收款（元）" width="150">
      <template slot-scope="scope">
               {{interval.interval(scope.row.amount5)}}
      </template>
    </el-table-column>
    <el-table-column prop="amount6" label="已回款（元）" width="110">
      <template slot-scope="scope">
               {{interval.interval(scope.row.amount6)}}
      </template>
    </el-table-column>
    <el-table-column prop="amount7" label="应收款（元）" width="110">
      <template slot-scope="scope">
               {{interval.interval(scope.row.amount7)}}
      </template>
    </el-table-column>
    <el-table-column prop="amount8" label="各工地进度" min-width='260px' ></el-table-column>
  </el-table>
     </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 假设这部分为服务端数据
      treeData: [
        {
          id: 1,
          bumen: "第一建筑工程公司",
          children: [
            {            
              id: 11,
              bumen: "第一建筑工程公司",
              name: "中颐和园（任部）",
              amount1: 35000035000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
               amount8: '地面施工中，本月已结算完毕【刘建勇】',
            },
             {
              id: 12,
               bumen: "第一建筑工程公司",
              name: "城投·奥文公馆项目",
              amount1: 350000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
               amount8: '地面施工中，本月已结算完毕【刘建勇】',
            },
             {
              id: 13,
               bumen: "第一建筑工程公司",
              name: "潍坊市坊子区基础教育建设项目（兴国小学幼儿园）",
              amount1: 350000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
               amount8: '地面施工中，本月已结算完毕【刘建勇】',
            },{
              id: 14,
               bumen: "第一建筑工程公司",
              name: "潍坊市坊子区基础教育建设项目（西王九年一贯制学校）",
              amount1: 350000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
              amount8: '地面施工中，本月已结算完毕【刘建勇】',
            }
          ],
        },        
        {
          id: 2,
          bumen: "第三建筑工程公司",
          children: [
            {
              id: 20,
              bumen: "第三建筑工程公司",
              name: "北海花园电梯改造项目(钢结构）",
              amount1: 350000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
               amount8: '地面施工中，本月已结算完毕【刘建勇】',
            },
            {
              id: 21,
              bumen: "第三建筑工程公司",
              name: "潍坊市北海花园A区（楼承板、边模）",
              amount1: 350000,
              amount2: 350000,
              amount3: 1122,
              amount4: '95%',
              amount5: 2222,
              amount6: 6546,
              amount7: 44,
              amount8: '地面施工中，本月已结算完毕【刘建勇】',
            },
          ],
        }
      ],
    };
  },
  created() {
    // 转换树形结构的数据，用来方便拆分合并单元格
    this.tableData = [];
      var mount1=0;

      var mount2=0;
      var mount3=0;
      var mount5=0;
      var mount6=0;
      var mount7=0;
    for(var a=0;a< this.treeData.length;a++){

if(this.treeData[a].children.length>0){
  for(var b=0;b<this.treeData[a].children.length;b++){ 
    mount1+=this.treeData[a].children[b].amount1
    mount2+=this.treeData[a].children[b].amount2
    mount3+=this.treeData[a].children[b].amount3
    mount5+=this.treeData[a].children[b].amount5
    mount6+=this.treeData[a].children[b].amount6
    mount7+=this.treeData[a].children[b].amount7
    // console.log(mount1)
  }
// console.log(b,amount1)
  var templist={
     id: this.treeData[a].children[this.treeData[a].children.length-1].id+1,
              bumen: this.treeData[a].children[this.treeData[a].children.length-1].bumen,
              name: "小计",
              amount1: mount1,
              amount2: mount2,
              amount3: mount3,
              amount4: '--',
              amount5: mount5,
              amount6: mount6,
              amount7: mount7,
              amount8: '--',
  }
  this.treeData[a].children.push(templist)
}
    }
    console.log( this.treeData)
    this.treeData.forEach((i) => {
      if (i.children) {
        i.children.forEach((j) => {
          j.parentId = i.id;
        });
      }
      if (i.children) {
        this.tableData.push(...i.children);
      } else {
        this.tableData.push(i);
      }
    });
  },
  methods: {
        handle(row,column,event,cell){
this.$router.push("/details/details");

},
  selectedstyle ({row, rowIndex}) {
    if(row.name == '小计'){
      return {
			"background-color": "rgba(242,244,246,1)"
			};
    }
	},
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const parent = this.treeData.find((i) => i.id === row.parentId);
        if (parent && row.id === parent.children[0].id) {
          return {
            rowspan: parent.children.length,
            colspan: 1,
          };
        } else if (parent && row.id !== parent.children[0].id) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>